/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-pascal-case */
import Profile_Customize_FontSize_Button from "./Profile_Customize_FontSize_Button";
import {connect} from "react-redux";
import { useEffect } from "react";

const Profile_Customize_FontSize = (props) => {
    const sizes = [12,14,16,18,20];
    const div = document.getElementsByName("line");

    useEffect(() => {
        div.forEach((elem) => {
            if ((elem.getAttribute("value") == 11) || ((elem.getAttribute("value") > props.font_size) && (props.font_size == 20))) {
                elem.className = `profile_customize_section_main_center_small profile_customize_section_color_button_${props.color_button}`
            } else if ((props.font_size != 20) && (elem.getAttribute("value") == 21)) {
                elem.className = `profile_customize_section_main_center_small profile_customize_section_main_center_button_unchosen_${props.color_button}`
            } else if ((elem.getAttribute("value") < props.font_size) && (elem.getAttribute("value") != 11) && (elem.getAttribute("value") != 21)) {
                elem.className = `profile_customize_section_main_center_middle profile_customize_section_color_button_${props.color_button}`
            } else {
                elem.className = `profile_customize_section_main_center_middle profile_customize_section_main_center_button_unchosen_${props.color_button}`
            }
        })
    });
    
    return(
        <div className="profile_customize_section">
            <h3 className="profile_customize_section_heading">Font size</h3>
            <div className={`profile_customize_section_main  background_change_${props.color_background}`}>
                <div className="profile_customize_section_main_left">Aa</div>
                <div className="profile_customize_section_main_center">
                    <div name="line" value="11" className={`profile_customize_section_main_center_small`}></div>
                    <div name="line" value="13" className={`profile_customize_section_main_center_middle`}></div>
                    <div name="line" value="15" className={`profile_customize_section_main_center_middle`}></div>
                    <div name="line" value="17" className={`profile_customize_section_main_center_middle`}></div>
                    <div name="line" value="19" className={`profile_customize_section_main_center_middle`}></div>
                    <div name="line" value="21" className={`profile_customize_section_main_center_small`}></div>
                    <div className="profile_customize_section_main_center_buttons">
                        {
                            sizes.map((size,i) => {
                                return <Profile_Customize_FontSize_Button 
                                    key={i} 
                                    size={size}
                                />
                            })
                        }
                    </div>
                </div>
                <div className="profile_customize_section_main_right">Aa</div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        color_background: state.getColorBackground.color_background,
        font_size: state.getFontSize.font_size,
        user: state.getUser.user
    }
}
export default connect(mapStateToProps)(Profile_Customize_FontSize);